
import { useEffect } from 'react';
import { useAnimation, motion } from 'framer-motion';

import './cart-warning.css';


export const CartWarning = () => {

    const controls = useAnimation();

    useEffect(() => {
        controls.start({
            x: 0,
            transition: {duration: 0.5}
        });

        const timer = setTimeout(() => {
            controls.start({
                x: '100%',
                transition: { duration: 0.5 }
            });
        }, 5000);

        return () => clearTimeout(timer);
    }, [controls])

    const hadleClick = () => {
        controls.start({
            x: '100%',
            transition: { duration: 0.5 }
        });
    }

    return (
        <motion.div className="wrap"
            animate={controls}
            initial={{x: '100%'}}
            
        >
            <span>На данний момент заклад закритий, спробуйте зробити замовлення в робочий час.</span>
            <div className='btn btn-dark m-1' onClick={hadleClick}> Зрозуміло</div>
        </motion.div>
    )
}